import URLS from '@d-shared/urls/urls';

class TrackingService {
  /* istanbul ignore next */
  sendEvent(formData, _navigator = navigator) {
    return _navigator.sendBeacon(URLS.api.events, formData);
  }
}

export default new TrackingService();
